import { useNarrow } from '../../../lib/use-narrow';
import type { SkillSummary } from '../../../lib/my-agents';
import { SkillsModalDesktop } from './SkillsModalDesktop';
import { SkillsModalMobile } from './SkillsModalMobile';

// The "Agent skills" modal, opened from the genome card's "{n} Skills". One behaviour, two
// presentations: a centered DS dialog on desktop (Figma 12801-159044) and a full-bleed sheet on a
// phone (Figma 6308-11642). The shared actions live in `useSkillsModal`; each surface only decides
// how it draws the team's skills. Below the narrow breakpoint the mobile sheet renders.
export function SkillsModal({ skills }: { skills: SkillSummary[] }) {
  const narrow = useNarrow();
  return narrow ? <SkillsModalMobile skills={skills} /> : <SkillsModalDesktop skills={skills} />;
}
